import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=3f391282&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=3f391282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f391282",
  null
  
)

export default component.exports